import { create } from 'zustand';

const useCommandStore = create((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

export default useCommandStore;
